import { atom } from 'recoil';

interface SnackbarState {
  message: string;
  color?: 'primary' | 'neutral' | 'danger' | 'success' | 'warning';
  [key: string]: any;
}

export const snackbarState = atom<SnackbarState>({
  key: 'snackbarState',
  default: {
    message: '',
  },
});
